import styled from 'styled-components';

export const TimeCellWrapper = styled.div`
  .react-datepicker {
    display: flex;
    .react-datepicker__time-container {
      width: 120px;
      .react-datepicker__time {
        .react-datepicker__time-box {
          width: 100%;
        }
      }
    }
  }
`;
